var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "word-file",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64v64H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a3313a",
    d: "m13 56-5.01-5H13v5zM51 56l5.01-5H51v5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M51 13h-7.99V5.01L51 13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M43 5H14.59A1.59 1.59 0 0 0 13 6.59v51a1.6 1.6 0 0 0 1.59 1.6h34.82A1.6 1.6 0 0 0 51 57.54V13h-8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c84d52",
    d: "M9 33h46a1 1 0 0 1 1 1v17H8V34a1 1 0 0 1 1-1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.67 43.13V46h-2v-8.18h3.2a3.09 3.09 0 0 1 2.22.73 2.55 2.55 0 0 1 .77 2 2.73 2.73 0 0 1-.34 1.35 2.39 2.39 0 0 1-1 .94 3.51 3.51 0 0 1-1.63.34zm2.2-2.63q0-1.08-1.2-1.08h-1v2.13h1q1.2 0 1.2-1.05zm9.82 3.5a3.63 3.63 0 0 1-1.48 1.45 4.7 4.7 0 0 1-2.27.52h-3.09v-8.15h3.09a4.75 4.75 0 0 1 2.27.51 3.54 3.54 0 0 1 1.48 1.44 4.3 4.3 0 0 1 .51 2.13 4.36 4.36 0 0 1-.51 2.1zm-2.13-.41a2.64 2.64 0 0 0 0-3.45 2.5 2.5 0 0 0-1.8-.61h-.93v4.67h.93a2.5 2.5 0 0 0 1.8-.58zm9.1-5.77v1.58H39.3v1.79h2.59v1.5H39.3V46h-2v-8.18z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c84d52",
    strokeMiterlimit: 10,
    d: "M32.9 10.53a5.14 5.14 0 0 1-.2 2.06c-.89 3.07-3.87 14.26-6.12 15.85-3.21 2.28-4.88-.31-3.17-2.15S35.44 22 38.73 22c4.28 0 3.73 3.79 1.3 3.56-2.74-.26-9.59-4.93-10-13.81-.18-3.16 2.56-3.75 2.87-1.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.390a5761d345714fc844ea9dd1ea69fa.svg";
export { ForwardRef as ReactComponent };